import { useQuery } from '@tanstack/react-query';
import { getUngroupedTenants } from 'Services';
import { RQ_UNGROUPED_TENANTS } from 'Utils';

const useGetUngroupedTenants = () => {
    return useQuery([RQ_UNGROUPED_TENANTS], getUngroupedTenants, {
        // never use cache as we want to get a real-time update on ungrouped tenants
        cacheTime: 0,
        select: (data) => {
            const tenantsWithSelectStates = data.map((tenant) => ({ ...tenant, isSelected: false })) ?? [];
            return { original: data, modifiedTenants: tenantsWithSelectStates };
        }
    });
};

export default useGetUngroupedTenants;
